import React from "react";
import { compose } from "redux";

import favoriteEntity from "fantastic/actions/favoriteEntity";
import connectActions from "fantastic/lib/connectActions";

import utils from "fantastic/lib/utils";
import saveable from "fantastic/components/hoc/saveable";
import droppable from "fantastic/components/hoc/droppable";

import CollectionEntity from "./CollectionEntity";
import SectionEntity from "./SectionEntity";
import ItemEntity from "./ItemEntity";

const Entity = props => {
  const entities = {
    CollectionEntity,
    SectionEntity,
    ItemEntity
  };
  const {
    data,
    favoriteEntity,
    id,
    tag_list,
    image_src,
    type,
    name,
    editable
  } = props;
  const Type = entities[props.type];
  const itemType = props.type.replace("Entity", "").toUpperCase() + "/NEW";

  const meta = { fromEntity: true };

  if (type === "ItemEntity") {
    meta.type = "ITEM/NEW";
    meta.kind = data.kind;
  }

  if (type === "SectionEntity") {
    meta.kind = data.kind;
    meta.type = "SECTION/NEW";
  }

  const styles = {
    backgroundImage: utils.url(props.image_src)
  };

  const favorite = { id, tag_list, data, image_src, name, type };

  return (
    <div
      className="fantastic-elements__element">
      { editable && <i className="fi fi-edit" onClick={() => favoriteEntity(favorite)}></i> }
      <Type data={data} itemType={itemType} meta={meta} styles={styles} src={props.image_src} />
      <div className="fantastic-elements__name">{props.name}</div>
    </div>
  );
};

export default compose(saveable(), connectActions({ favoriteEntity }))(Entity);
//export default compose(droppable(["SECTION", "ITEM"]), saveable())(Entity);
